// Shared by UI, network requests and background workers. Short operations stay
// quiet; visible jobs remain until their owner finishes or cancels them.
const jobs = new Map(), listeners = new Set();
let snapshot = [], nextId = 0;
const publish = () => { snapshot = [...jobs.values()].filter(j => j.visible); listeners.forEach(fn => fn()); };
export const subscribeActivity = fn => { listeners.add(fn); return () => listeners.delete(fn); };
export const activitySnapshot = () => snapshot;

export function beginActivity(label, { delay = 300, message = '', progress = null, cancel } = {}) {
  const id = ++nextId;
  jobs.set(id, { id, label, message, progress, cancel, started: Date.now(), visible: delay === 0 });
  const timer = delay ? setTimeout(() => { const job = jobs.get(id); if (job) { jobs.set(id, { ...job, visible: true }); publish(); } }, delay) : null;
  if (!delay) publish();
  return {
    update(patch) {
      const job = jobs.get(id); if (!job) return;
      const next = { ...patch };
      if ('progress' in next) next.progress = Number.isFinite(next.progress) ? Math.max(0, Math.min(1, next.progress)) : null;
      jobs.set(id, { ...job, ...next });
      if (job.visible) publish();
    },
    finish() { clearTimeout(timer); const job = jobs.get(id); jobs.delete(id); if (job?.visible) publish(); }
  };
}

// Allow React to commit and the browser to paint feedback before local work.
export const yieldToPaint = () => new Promise(resolve => {
  if (typeof requestAnimationFrame === 'function' && !document.hidden) requestAnimationFrame(() => setTimeout(resolve, 0));
  else setTimeout(resolve, 0);
});

export async function withActivity(label, work) {
  const job = beginActivity(label, { delay: 0 });
  try { await yieldToPaint(); return await work(job); } finally { job.finish(); }
}
